import { Navigate } from "react-router-dom";
import { DEFAULT_DOC_SECTION } from "./toc";

export default function DocsIndexRedirect() {
  return <Navigate to={`/docs/${DEFAULT_DOC_SECTION}`} replace />;
}
